export const CustomIconSMS = ({ className, size = 20 }: { className?: string; size?: number }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.3 16.0997L3 19.9997L7.7 18.9997C11.659 20.9217 16.608 19.9417 19.274 16.7067C21.94 13.4717 21.5 8.98272 18.245 6.20572C14.99 3.42972 9.926 3.22472 6.4 5.72572C2.874 8.22772 1.976 12.6627 4.3 16.0997Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.50024 10.3203V14.1662M9.50024 11.6023C9.50024 11.2623 9.60154 10.9362 9.78185 10.6958C9.96217 10.4554 10.2067 10.3203 10.4617 10.3203H10.7021C11.0208 10.3203 11.3265 10.4891 11.5519 10.7897C11.7773 11.0902 11.9039 11.4978 11.9039 11.9228M11.9039 11.9228V14.1662M11.9039 11.9228V12.5638M11.9039 11.9228C11.9039 11.4978 12.0306 11.0902 12.256 10.7897C12.4813 10.4891 12.787 10.3203 13.1058 10.3203C13.4245 10.3203 13.7302 10.4891 13.9556 10.7897C14.181 11.0902 14.3076 11.4978 14.3076 11.9228V14.1662"
      stroke="currentColor"
      strokeWidth="1.38462"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 13.666C6.1725 13.966 6.629 14.166 7 14.166C7.26522 14.166 7.51957 14.0607 7.70711 13.8731C7.89464 13.6856 8 13.4312 8 13.166C8 12.9008 7.89464 12.6464 7.70711 12.4589C7.51957 12.2714 7.26522 12.166 7 12.166C6.73478 12.166 6.48043 12.0607 6.29289 11.8731C6.10536 11.6856 6 11.4312 6 11.166C6 10.9008 6.10536 10.6464 6.29289 10.4589C6.48043 10.2714 6.73478 10.166 7 10.166C7.373 10.166 7.828 10.363 8 10.666"
      stroke="currentColor"
      strokeWidth="1.38462"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 13.666C16.1725 13.966 16.629 14.166 17 14.166C17.2652 14.166 17.5196 14.0607 17.7071 13.8731C17.8946 13.6856 18 13.4312 18 13.166C18 12.9008 17.8946 12.6464 17.7071 12.4589C17.5196 12.2714 17.2652 12.166 17 12.166C16.7348 12.166 16.4804 12.0607 16.2929 11.8731C16.1054 11.6856 16 11.4312 16 11.166C16 10.9008 16.1054 10.6464 16.2929 10.4589C16.4804 10.2714 16.7348 10.166 17 10.166C17.373 10.166 17.828 10.363 18 10.666"
      stroke="currentColor"
      strokeWidth="1.38462"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
